import languageData from "../containers/Topbar/languageData";

const STORAGE_KEY = "landingLang";
const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = languageData.map((item) => item.locale);

const normalizeLang = (value) => (typeof value === "string" ? value.toLowerCase() : "");

// "pt-BR" -> "pt", "zh-Hans-CN" -> "zh". Desteklenmeyen etiketlerde null doner.
const matchSupported = (value) => {
  const normalized = normalizeLang(value);
  if (!normalized) return null;
  if (SUPPORTED_LANGUAGES.includes(normalized)) return normalized;
  const base = normalized.split("-")[0];
  return SUPPORTED_LANGUAGES.includes(base) ? base : null;
};

export const detectPreferredLanguage = () => {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const stored = matchSupported(window.localStorage.getItem(STORAGE_KEY));
  if (stored) {
    return stored;
  }

  const navLangs = Array.isArray(window.navigator.languages)
    ? window.navigator.languages
    : [window.navigator.language];
  const candidates = navLangs.length ? navLangs : [];

  for (const candidate of candidates) {
    const matched = matchSupported(candidate);
    if (matched) return matched;
  }

  return DEFAULT_LANGUAGE;
};

/* ARAPÇA SAĞDAN SOLA (v2): dil "ar" ise belgenin yönü rtl olur; aksi hâlde ltr.
   Tek yer: hem dil değişince hem uygulama açılışında çağrılır. */
export const applyDocumentDirection = (lang) => {
  if (typeof document === "undefined") return;
  const l = matchSupported(lang) || detectPreferredLanguage();
  const dir = l === "ar" ? "rtl" : "ltr";
  if (document.documentElement.getAttribute("dir") !== dir) document.documentElement.setAttribute("dir", dir);
  if (document.documentElement.getAttribute("lang") !== l) document.documentElement.setAttribute("lang", l);
};

export const persistPreferredLanguage = (lang) => {
  if (typeof window === "undefined") return;
  const matched = matchSupported(lang);
  if (!matched) return;
  window.localStorage.setItem(STORAGE_KEY, matched);
  applyDocumentDirection(matched);
};
